import { gql } from '@apollo/client';

/**
 * 站点内联 AB 映射加载（#6/G6）：edit/view 打开站点表单时取该站点当前 AB 地址映射集。
 * 对应 api-server CooperationWarehouseQuery.getStationAbMappings。
 */
export const GET_STATION_AB_MAPPINGS = gql`
  query GetStationAbMappings($cooperationWarehouseId: Long!) {
    getStationAbMappings(cooperationWarehouseId: $cooperationWarehouseId) {
      id
      originAddressLine1
      originAddressLine2
      originCity
      originState
      originZipcode
      contactName
      contactPhone
      channelId
    }
  }
`;

export interface StationAbMapping {
  id?: number | null;
  originAddressLine1?: string | null;
  originAddressLine2?: string | null;
  originCity?: string | null;
  originState?: string | null;
  originZipcode?: string | null;
  contactName?: string | null;
  contactPhone?: string | null;
  channelId?: number | null;
}

export interface GetStationAbMappingsResponse {
  getStationAbMappings: StationAbMapping[];
}

export interface GetStationAbMappingsVariables {
  cooperationWarehouseId: number;
}
